<template>
  <div class="edit_main">
    <Form class="fx_1" ref="editModel" :model="editModel" :rules="ruleValidate" :label-width="100" inline>
      <FormItem label="科室名称" prop="departmentName">
        <Input class="w-250" v-model="editModel.departmentName"></Input>
      </FormItem>
      <FormItem label="科室编号" prop="departmentCode">
        <Input class="w-250" v-model="editModel.departmentCode"></Input>
      </FormItem>
      <FormItem label="科室类型" prop="departmentTypeCode">
        <Select class="w-250" v-model="editModel.departmentTypeCode" clearable>
          <Option
            v-for="(item, index) in departmentTypeSelect"
            :value="item.dictionaryID"
            :key="index"
          >{{ item.dictionaryValue }}</Option>
        </Select>
      </FormItem>

      <FormItem label="所属机构">
        <Button type="primary" @click="treeModel=true">选择机构</Button>
        <span class="ml-5">{{editModel.organName}}</span>
      </FormItem>
    </Form>
    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')">确 定</Button>
    </div>

    <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

export default {
  components: { organTree },
  data: function () {
    return {
      treeModel: false,
      organParentName: "",
      editModel: {
        departmentID: "",
        departmentName: "",
        departmentCode: "",
        departmentType: '',
        departmentTypeCode:'',
        organID: "",
        organName: "",
      },
      departmentTypeSelect: [],
      ruleValidate: {
        departmentName: [
          {
            required: true,
            message: "科室名称不能为空",
          },
        ],
        departmentCode: [
          {
            required: true,
            message: "科室编号不能为空",
          },
          
        ],
        departmentTypeCode: [
          {
            required: true,
            message: "科室类型不能为空",
          },
        ],
      },
    };
  },

  activated: function () {
    this.$common.getDictionary("科室类型").then((data) => {
      this.departmentTypeSelect = data;
    });
    this.initData(this.$route.query.id);
  },

  methods: {
    initData(id) {
      this.$api.get(`department/getById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.editModel = rsp.data;
        }
      });
    },
    returnBack: function () {
      this.$router.push("department");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (!this.editModel.organID) {
            this.$Message.warning("请选择所属机构");
            return;
          }
          this.editModel.departmentType=this.editModel.departmentTypeCode
          this.$api.post("department/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
            }
          });
        }
      });
    },
    selectTreeData: function (data) {
      this.editModel.organID = data[0].organID;
      this.editModel.organName = data[0].title;
    },
  },
};
</script>
<style scoped>
</style>